<template>
  <div class="t-lk-services-item">
    <div class="t-lk-services-item__img">
      <img v-if="item.img" :src="item.img" :alt="item.name" />
    </div>
    <div class="t-lk-services-item__content" :class="{ _width: !item.img }">
      <div class="t-lk-services-item__name">{{ item.name }}</div>
      <div class="t-lk-services-item__text t-html" v-html="item.text"></div>

      <div
        v-if="isAct"
        class="t-btn _lk _border-gray t-lk-services-item__btn"
        @click="
          modalType_actRequestOpen({
            overflowNone: true,
          })
        "
      >
        {{ item.btn }}
      </div>

      <template v-else-if="isRequest">
        <a
          v-if="$root.__AXOFT__.isRU"
          class="t-btn _lk _border-gray t-lk-services-item__btn"
          :href="`${$root.lk.b2bPlatformUrl}/purchases/requests/all-requests?pages=1`"
          target="_blank"
        >
          {{ item.btn }}
        </a>
        <div
          v-else
          class="t-btn _lk _border-gray t-lk-services-item__btn"
          @click="
            modalType_requestOpen({
              title: item.btn,
              options: optionsRequest,
              button: $root.staticText.forms.btn,
            })
          "
        >
          {{ item.btn }}
        </div>
      </template>

      <div
        v-else-if="isDropdownDoc && item.link.length > 1"
        class="t-lk-services-item__btn js-service-item"
        :class="{ _open: openChangeBlock === index }"
        @click.prevent.stop="openChangeStatus(item, index)"
      >
        <div class="t-lk-leads-work-change__item-top">
          {{ item.btn }}
          <svg v-if="item.link.length" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.69526 9.02876C3.95561 8.76841 4.37772 8.76841 4.63807 9.02876L10 14.3907L15.3619 9.02876C15.6223 8.76841 16.0444 8.76841 16.3047 9.02876C16.5651 9.28911 16.5651 9.71122 16.3047 9.97157L10.4714 15.8049C10.2111 16.0653 9.78895 16.0653 9.5286 15.8049L3.69526 9.97157C3.43491 9.71122 3.43491 9.28911 3.69526 9.02876Z"
              fill="black"
            />
          </svg>
        </div>

        <transition name="fade">
          <div v-if="openChangeBlock === index" class="t-lk-leads-work-change__container">
            <a
              v-for="doc in item.link"
              :href="doc.link"
              download
              class="t-lk-leads-work-change__item"
              @click.stop=""
              :title="doc.name"
            >
              {{ trimFileId(doc.name) }}
            </a>
          </div>
        </transition>
      </div>

      <a
        v-else-if="isDropdownDoc && item.link.length === 1"
        :href="item.link[0].link"
        download
        class="t-btn _lk _border-gray t-lk-services-item__btn"
      >
        {{ item.btn }}
      </a>

      <a v-else-if="item.isTarget" :href="item.link" target="_blank" class="t-btn _lk _border-gray t-lk-services-item__btn">
        {{ item.btn }}
      </a>
      <router-link v-else :to="item.link" class="t-btn _lk _border-gray t-lk-services-item__btn">
        {{ item.btn }}
      </router-link>

      <router-link v-else-if="!isDropdownDoc && !item.anchor" :to="item.link" class="t-btn _lk _border-gray t-lk-services-item__btn">
        {{ item.btn }}
      </router-link>

      <router-link
        v-else-if="!isDropdownDoc && item.anchor"
        :to="{ name: 'lk-services', hash: '#' + item.anchor }"
        class="t-btn _lk _border-gray t-lk-services-item__btn"
      >
        {{ item.btn }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'lk-services-item',
  props: {
    item: Object,
    index: Number,
    optionsRequest: Array,
    isDropdownDoc: {
      type: Boolean,
      default: false,
    },
    isAct: {
      type: Boolean,
      default: false,
    },
    isRequest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openChangeBlock: -1,
    }
  },
  methods: {
    ...mapActions('modal', ['modalType_requestOpen', 'modalType_actRequestOpen']),
    openChangeStatus(item, index) {
      if (this.openChangeBlock === index) {
        this.openChangeBlock = -1
      } else {
        this.openChangeBlock = index
      }
    },
    clickOutside() {
      let container = document.querySelector('.js-service-item')
      if (container && event.target !== container && !container.contains(event.target)) {
        this.openChangeBlock = -1
      }
    },
    trimFileId(fileName) {
      if (typeof fileName !== 'string') return ''
      return fileName.replace(/_[^_]+(?=\.[a-z0-9]+$)/i, '')
    },
  },
  mounted() {
    document.addEventListener('click', this.clickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside)
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-services-item/lk-services-item.vue